import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignupView from '../views/SignupView.vue'
import ConfirmView from '../views/ConfirmView.vue'
import LoginView from '../views/LoginView.vue'
import UserSettingView from '../views/UserSettingView.vue'
import PlayListSettingView from '../views/PlaylistSettingView.vue'
import FavoriteEventsView from '../views/FavoriteEventsView.vue'
import SignUpEvent from '../components/SignUpEvent.vue'
import SignUpEventMulti from '../components/SignUpEventMulti.vue'
import Thank from '../components/Thank.vue'
import Error from '../components/Error.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/map',
    name: 'map',
    component: HomeView
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: HomeView  
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: ConfirmView
  },
  {
    path: '/confirm/:user_id/:code',
    name: 'confirm2',
    component: ConfirmView
  },  
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },  
  {
    path: '/usersetting',
    name: 'usersetting',
    component: UserSettingView
  },  
  {
    path: '/playlistsetting',
    name: 'playlistsetting',
    component: PlayListSettingView
  },  
  {
    path: '/favoriteevents',
    name: 'favoriteevents',
    component: FavoriteEventsView
  },  
  {
    path: '/signupevent',
    name: 'signupevent',
    component: SignUpEvent
  },  
  {
    path: '/signupeventmulti',
    name: 'signupeventmulti',
    component: SignUpEventMulti
  },  
  {
    path: '/thank',
    name: 'thank',
    component: Thank
  },  
  {
    path: '/error',
    name: 'error',
    component: Error
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
